<template>
    <div class="home">
        <banner type="1"></banner>
        <div class="w-1200 mt-100" style="padding-bottom: 160px;">
            <div class="text-center font-24 font-500">关于我们</div>
            <div class="text-center mt-6 font-500">HUAPUA：提供诊断原料的研发、生产、和技术服务的高科技企业</div>
            <div class="text-center mt-2 font-500">技术平台：抗体和抗原制备平台、分子原料平台、辅料平台、试剂开发技术平台</div>
            <div class="text-center mt-150 font-24 font-500">了解产品</div>
            <div class="text-center mt-6">以自己的品牌特色和优势促进我国IVD产业质量提升、成本降低，增强我国核心原料产品的市场竞争力</div>
            <div class="mt-50 flex font-500 flex-wrap productNavBox">
                <div class="productNav" v-for="item in productCate" :key="item.id"
                     @click="$router.push(`/pc/product-center?id=${item.id}&name=${item.name}`)">
                    <img :src="item.pic" alt="">
                    <div class="font-20">{{item.name}}</div>
                </div>
            </div>
            <div class="flex flex-j-c flex-a-c mt-8" @click="$router.push('/pc/pets')">
                <img src="../assets/img/congwu.png" width="166" height="180" alt="">
                <div class="ml-8 font-500 font-24 color-red">宠物检测</div>
            </div>
        </div>
        <div class="w-1200 bgc-gray BFC">
            <div class="text-center font-24 mt-100 font-500">定制服务</div>
            <div class="text-center mt-6">在日常诊断产品开发过程中，您是否有无法解决的困惑?
                那么，让我们来助您一臂之力。
            </div>
            <div class="flex" style="margin-top: 80px;">
                <img src="../assets/img/dingzifuwu.jpg" width="320" alt="">
                <div class="customizedServicesTextBox ml-8 font-18 ">
                    <div>
                        HUAPUA基于十多年来在体外诊断方面的产品与技术服务经验，能够为您提供半成品/成品试剂盒开发/定制服务；
                    </div>
                    <div class="mt-6">
                        小分子衍生物设计专家，可针对您的需求，改造或者合成小分子化合物的衍生物、提供半抗原衍生物；
                    </div>
                    <div class="mt-6">
                        在使用HUAPUA制备的试剂盒时，根据客户要求免费提供技术支持，全程跟踪您实验进度，及时解决您在实验上碰到问题和情况。
                    </div>
                    <div class="font-600 color-red mt-6"
                         @click="$router.push(`/pc/customized-services`)">点击查看更多>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-1200" style="padding: 145px 0 200px;">
            <div class="text-center font-500 font-24">优品推荐</div>
            <div class="recommendBox flex flex-wrap mt-50">
                <div class="recommend" v-for="item in recommendCate" :key="item.id"
                     @click="$router.push({
                    path:'/pc/recommend',
                    query:{
                    id:item.id,
                    name:item.name
                    }
                })">
                    <img :src="item.pic" alt="">
                    <div class="text-center font-500 font-20 mt-4">{{item.name}}
                        <img src="../assets/img/add.png" width="18" height="18" alt=""></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'home',
        components: {},
        data() {
            return {
                productCate: [],
                banner: [],
                recommendCate: []
            }
        },
        async mounted() {
            this.getProductCate()
            this.getRecommendCate()
        },
        methods: {
            // 获取首页产品
            async getProductCate() {
                this.productCate = await this.$api.getProductCate({top: 1})
            },
            //    获取首页优品推荐
            async getRecommendCate() {
                this.recommendCate = await this.$api.getRecommendCate({top: 1})
            }
        }
    }
</script>
<style scoped lang="scss">
    .productNavBox {
        .productNav {
            width: 224px;
            height: 300px;
            background: #BD2C2E;
            padding: 50px 35px 30px;
            color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-left: 20px;

            &:nth-child(5n+1) {
                margin-left: 0;
            }

            &:nth-child(n+6) {
                margin-top: 20px;
            }

            img {
                width: 120px;
                height: 120px;
            }

            div {
                height: 91px;
                width: 154px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 10px;
            }
        }
    }

    .recommendBox {
        .recommend {
            margin-left: 20px;

            &:nth-child(3n+1) {
                margin-left: 0;
            }

            &:nth-child(n+4) {
                margin-top: 20px;
            }

            & > img {
                width: 380px;
                height: 300px;
            }
        }
    }

    .customizedServicesTextBox {
        padding: 24px 50px;
        background-color: #fff;
        position: relative;

        div {
            line-height: 45px;
        }

        .san {
            position: absolute;
            left: -20px;
            top: 70px;
            width: 0px;
            height: 0px;
            border-top: 20px solid transparent;
            border-right: 20px solid #fff;
            border-bottom: 20px solid transparent;
            z-index: 1;
        }
    }
</style>
